// extracted by mini-css-extract-plugin
export default {"grid":"ResourceTileGrid_grid__2jUhl"};